<template>
    <div class="search-page">
        <div class="search-header-wrap">
            <div class="search-header-content">
                <div>
                    <div class="icon" @click="searchFunc"></div>
                    <input type="text" v-model="keyword" placeholder="검색어를 입력해주세요" v-on:keyup.enter="searchFunc">
                    <span v-show="keyword" @click="keyword=''"></span>
                </div>

            </div>
        </div>
        <div class="search-tab-wrap">
            <div class="search-tab-content">
                <div class="tab" @click="changeSearchTabFunc('tournament')" :class="tab==='tournament' ? 'active' : ''">대회</div>
                <div class="tab" @click="changeSearchTabFunc('gym')" :class="tab==='gym' ? 'active' : ''">체육관</div>
                <div class="tab" @click="changeSearchTabFunc('player')" :class="tab==='player' ? 'active' : ''">선수</div>
            </div>
        </div>

        <div class="default-search" v-if="!$route.query.keyword">

            <div class="recent-keyword-wrap">
                <p class="recent-title">최근 검색어</p>
                <div class="recent-keyword-list">
                    <div class="keyword" v-for="(keyword, keywordIndex) in recentKeyword">
                        <p @click="keywordSearchFunc(keyword)">{{keyword}}</p>
                        <div class="fl" @click="delRecentKeyword(keywordIndex)"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="search-wrap" v-else>

            <div class="recent-keyword-show-wrap" @click="recentKeywordShow=true" v-show="!recentKeywordShow">
                <p>최근검색어 보기</p>
            </div>
            <div class="recent-keyword-wrap" v-show="recentKeywordShow">

                <div class="recent-keyword-show-wrap">
                </div>
                <span @click="recentKeywordShow=false"></span>
                <p class="recent-title">최근 검색어</p>
                <div class="recent-keyword-list">
                    <div class="keyword" v-for="(keyword, keywordIndex) in recentKeyword">
                        <p @click="keywordSearchFunc(keyword)">{{keyword}}</p>
                        <div class="fl" @click="delRecentKeyword(keywordIndex)"></div>
                    </div>
                </div>
            </div>

            <TournamentSearchPage v-if="tab==='tournament'"></TournamentSearchPage>
            <GymSearchPage v-else-if="tab==='gym'"></GymSearchPage>
            <PlayerSearchPage v-else></PlayerSearchPage>

        </div>

        <AlertModal content="검색어를 입력해주세요" @close="alertShow=false" v-if="alertShow"></AlertModal>
    </div>
</template>
<script>
    import AlertModal from "../modal/AlertModal";
    import TournamentSearchPage from "./TournamentSearchPage";
    import GymSearchPage from "./GymSearchPage";
    import PlayerSearchPage from "./PlayerSearchPage";
    export default {
        components: {PlayerSearchPage, GymSearchPage, TournamentSearchPage, AlertModal},
        data() {
            return {
                tab: this.$route.query.tab || 'tournament',
                is_search: false,
                keyword: this.$route.query.keyword || null,

                alertShow:false,

                recentKeyword: JSON.parse(localStorage.getItem('recent_keyword')) || [],

                recentKeywordShow:true
            }
        },
        methods: {
            searchFunc() {
                if(!this.keyword){
                    this.alertShow = true
                }else{
                    let recentKeywordList = JSON.parse(localStorage.getItem('recent_keyword')) || []

                    if(recentKeywordList.includes(this.keyword)){
                        const index = recentKeywordList.indexOf(this.keyword)
                        recentKeywordList.splice(index,1)
                    }
                    console.dir(recentKeywordList.length)
                    if(recentKeywordList.length > 4 ){
                        recentKeywordList.splice(0, 1)
                    }

                    recentKeywordList.push(this.keyword)

                    localStorage.setItem('recent_keyword', JSON.stringify(recentKeywordList))

                    const sportType = localStorage.getItem('selectSportType')|| null
                    const temp  = {
                        sportType: sportType,
                        searchTerm: this.keyword,
                        playerName: this.keyword,
                        keyword: this.keyword
                    }

                    const query = this.$route.query


                    this.$router.push({path: `/search`, query: Object.assign({}, query, temp)})
                }
            },
            delRecentKeyword(keywordIndex){
                this.recentKeyword.splice(keywordIndex, 1)
                localStorage.setItem('recent_keyword', JSON.stringify(this.recentKeyword))
            },
            keywordSearchFunc(keyword){
                this.keyword = keyword
                this.searchFunc()
            },
            changeSearchTabFunc(tab){
                const query = this.$route.query

                this.$router.replace({path: this.$route.path, query: Object.assign({}, query, {tab: tab})})
            }
        }
    }
</script>
